import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import ProfilePhoto from '@contact/components/Add/ProfilePhoto.vue'
import EditForm from '@contact/components/Edit/EditForm.vue'
import api from '@contact/api'
import { ContactsStoredType } from '../types/enums'
import { mapGetters, mapMutations } from 'vuex'
import * as types from '@contact/store/types'
@Component({
  components: { 
    ProfilePhoto,
    EditForm
  },
  computed: {
    ...mapGetters({
      item: types.CURRENT_CONTACT_ITEM
    })
  },
  methods: {
    ...mapMutations({
        setCurreuntItem: types.CURRENT_CONTACT_ITEM,
    })
  }
})
export default class EditContainer extends Vue {

  //
  // ────────────────────────────────────────────────────── I ──────────
  //   :::::: G E T T E R S : :  :   :    :     :        :          :
  // ────────────────────────────────────────────────────────────────
  //

  item!: contacts.ContactItem

  //
  // ────────────────────────────────────────────────────────── I ──────────
  //   :::::: M U T A T I O N S : :  :   :    :     :        :          :
  // ────────────────────────────────────────────────────────────────────
  //
  
  setCurreuntItem!: (item: contacts.ContactItem) => void

  //
  // ────────────────────────────────────────────────────── I ──────────
  //   :::::: M E T H O D S : :  :   :    :     :        :          :
  // ────────────────────────────────────────────────────────────────
  //

  async save() {
    const item = this.item;
    
    if (item.givenName === '') {
      await(window as any).alertAsync(this.$t('M_Contact_InvalidValueError6').toString());
      return false;
    } else {
      item.displayName = item.surname == null ? item.givenName : item.surname?.concat(item.givenName)
      const fields: mail.api.FieldOption[] = [
        { key: 'GivenName', value: item.givenName },
        {
            key: 'DisplayName',
            value: item.surname?.concat(item.givenName),
        },
      ];
      if (item.email) {
        fields.push({
          key: 'EmailAddresses',
          indexedKey: 'EmailAddress1',
          value: item.email,
        });
      }
      if (item.surname) {
        fields.push({ key: 'Surname', value: item.surname });
      }
      if (item.mobile) {
        fields.push({
          key: 'PhoneNumbers',
          indexedKey: 'MobilePhone',
          value: item.mobile,
        });
      }
      if (item.companyName) {
        fields.push({ key: 'CompanyName', value: item.companyName });
      }
      if (item.department) {
        fields.push({ key: 'Department', value: item.department });
      }
      if (item.jobTitle) {
        fields.push({ key: 'JobTitle', value: item.jobTitle });
      }
      if (item.businessPhone) {
        fields.push({
          key: 'PhoneNumbers',
          indexedKey: 'BusinessPhone',
          value: item.businessPhone,
        });
      }
      if (item.businessFax) {
        fields.push({
          key: 'PhoneNumbers',
          indexedKey: 'BusinessFax',
          value: item.businessFax,
        });
      }
      if (item.businessHomePage) {
        fields.push({
          key: 'BusinessHomePage',
          indexedKey: 'BusinessHomePage',
          value: item.businessHomePage,
        });
      }
  
      if (item.businessAddress && item.businessAddress.street) {
        fields.push({
          key: 'PhysicalAddresses',
          indexedKey: 'BusinessAddressStreet',
          value: {
            Street: item.businessAddress.street,
            PostalCode: item.businessAddress.postalCode,
          },
        });
      }
      if (item.homeAddress && item.homeAddress.street) {
        fields.push({
          key: 'PhysicalAddresses',
          indexedKey: 'HomeAddressStreet',
          value: {
            Street: item.homeAddress.street,
            PostalCode: item.homeAddress.postalCode,
          },
        });
      }
      if (item.officeLocation) {
          fields.push({ key: 'OfficeLocation', value: item.officeLocation });
      }
      const data: mail.api.DynamicApiOptions = {
        fields: fields,
        id: item.id,
        type: 'Contact',
      };

      api.contact.editContact(data, ContactsStoredType.EWS).then((res) => {
        this.setCurreuntItem(item)
        this.$router.push({ name: 'contact-view' })
      })
    }
  }
}
